import React, { useState, useEffect, createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCardMetaDataApi } from '~/pages/CardSaga/cardMetaDataSlice';
import PropTypes from 'prop-types';
export const FormTabContext = createContext();
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import isEmpty from 'lodash/isEmpty';

function FormTabProvider({
    initialValues,
    schema,
    formGroups,
    children,
    cardInformation,
    frontSides,
    backSides,
    allPictures,
    crops,
    displayFormikState,
}) {
    const { cardMetaData } = useSelector((state) => state.cardSaga.cardMetaData);
    const cardFrontRef = React.useRef(null);

    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);
    const [resetCount, setResetCount] = useState(0);
    const [navTitles, setNavTitles] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        setNavTitles(() => {
            formGroups.forEach((item) => (item.hasError = false));

            return formGroups;
        });
    }, [formGroups]);

    useEffect(() => {
        if (isEmpty(cardMetaData)) {
            dispatch(fetchCardMetaDataApi(navigate));
        }
    }, []);
    const contextValue = {
        initialValues,
        schema,
        cardMetaData,
        cardInformation,
        formGroups,
        resetCount,
        setResetCount,
        navTitles,
        setNavTitles,
        apiValidationErrors,
        clearApiValidationErrors,
        frontSides,
        backSides,
        allPictures,
        crops,
        cardFrontRef,
        displayFormikState,
    };

    return <FormTabContext.Provider value={contextValue}>{children}</FormTabContext.Provider>;
}
FormTabProvider.defaultProps = {
    frontSides: [],
    backSides: [],
    allPictures: [],
    crops: [],
    displayFormikState: true,
};
FormTabProvider.propTypes = {
    initialValues: PropTypes.object.isRequired,
    schema: PropTypes.func.isRequired,
    formGroups: PropTypes.array.isRequired,
    cardInformation: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    frontSides: PropTypes.array,
    backSides: PropTypes.array,
    allPictures: PropTypes.array,
    crops: PropTypes.array,
    displayFormikState: PropTypes.bool,
};

const useFormTab = () => {
    const contextValues = useContext(FormTabContext);

    return { ...contextValues };
};

export { FormTabProvider, useFormTab };
// Ref: https://www.robinwieruch.de/react-usecontext-hook/
